import React from 'react';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { EventOutlined } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import { upperFirst } from 'lodash';

import ReadMore from '../ReadMore/ReadMore';
import { moment } from '../../I18n';
import { isImplementationStep } from '../../Utils/Steps';

function PostStepShow({ step }: any) {
  const { start_at: startAt, end_at: endAt, description, step_type: stepType } = step;
  const intl = useIntl();

  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Grid>
          <EventOutlined />
        </Grid>
        <Grid>
          {isImplementationStep(stepType) ? (
            <Typography variant="body2" color="textSecondary">
              {upperFirst(moment(startAt).fromNow())}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{
                display: 'inline',
              }}
            >
              <FormattedMessage
                id="POSTS.SHOW.FROM_DATE_TO_DATE_WITH_TIME"
                values={{
                  startAtDate: moment(startAt).format(
                    intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }),
                  ),
                  startAtHour: moment(startAt).format('LT'),
                  endAtDate: moment(endAt).format(
                    intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }),
                  ),
                  endAtHour: moment(endAt).format('LT'),
                  strong: (...chunks: any[]) => <strong>{chunks}</strong>,
                }}
              />
            </Typography>
          )}
        </Grid>
      </Grid>

      {description && (
        <Box sx={{ mb: 3 }}>
          <ReadMore content={description} expand={false} />
        </Box>
      )}
    </>
  );
}

PostStepShow.propTypes = {
  step: PropTypes.shape({
    start_at: PropTypes.string.isRequired,
    end_at: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default PostStepShow;
